import PreviewWebsitePage from './PreviewWebsitePage';
import PreviewBrowserTab from './PreviewBrowserTab';
import { Button, Divider, Flex, Spinner, Text } from '@chakra-ui/react';
import { useContext } from 'react';
import PassDownloadTemplateContext from '../../../store/client/PassDownloadTemplateContext';

const PreviewDesktop = ({ editingLang }) => {
  const passDownloadCtx = useContext(PassDownloadTemplateContext);
  return (
    <Flex direction="column" align="center">
      <PreviewWebsitePage
        previewData={passDownloadCtx}
        editingLang={editingLang}
      />
      <Divider py={4} />
      <PreviewBrowserTab editingLang={editingLang} />
      <Divider py={4} />
      <Flex direction="column" mt={8} w="100%" align="center">
        <Text
          textStyle="bodyBold"
          fontSize="16px"
          color="secondaryDark"
          textAlign={{ base: 'center', md: 'left' }}
        >
          Custom spinner preview
        </Text>
        <Spinner
          data-testid="spinner"
          width="60px"
          height="60px"
          speed="3s"
          borderWidth="8px"
          color={passDownloadCtx.componentFillColor}
          emptyColor="gray.200"
          mt={4}
        />
      </Flex>
      <Divider py={4} />
      <Flex direction="column" mt={8} w="100%" align="center">
        <Text
          textStyle="bodyBold"
          fontSize="16px"
          color="secondaryDark"
          textAlign={{ base: 'center', md: 'left' }}
        >
          Custom button preview
        </Text>
        <Button
          mt={4}
          data-testid="go-to-google-wallet-button"
          size="md"
          bg={passDownloadCtx.componentFillColor}
          color={passDownloadCtx.componentFontColor}
          _hover={{
            bg: passDownloadCtx.componentFillColor,
            color: passDownloadCtx.componentFontColor,
            opacity: 0.9,
          }}
        >
          Button
        </Button>
      </Flex>
    </Flex>
  );
};

export default PreviewDesktop;
